import { colorPrimary } from '@atlas-frontend/design-tokens';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Badge, Button, ButtonProps, Flex } from 'antd';
import translations from './ClearButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('table-shell');
addTranslations(translations);

export interface ClearButtonProps extends ButtonProps {
  count?: number;
  label?: string;
}

export function ClearButton({ count, id, onClick, label }: ClearButtonProps) {
  const { t } = useTranslation();
  return (
    <Button id={id} onClick={onClick}>
      <Flex gap="small" align="center">
        {label || t('button.clear-filters')}
        <Badge count={count} showZero color={colorPrimary} />
      </Flex>
    </Button>
  );
}
